import ChoosingMonth from '../choosing-month/choosing-month';
import { StatusQuestionnaire, DirectionsRequirement, UniversalObject, Department, Block } from '../../types/data';
import ExportExcelSummary from '../export-excel-summary/export-excel-summary';
import ExportExcelMain from '../export-excel-main/export-excel-main';
import { getCurrentQuarterAndYear } from '../../utils/utils';
import { Quarter } from '../../types/data';

type ActionListProps = {
  group?: UniversalObject;
  factory?: UniversalObject;
  gop?: UniversalObject;
  dataMain?: Block[];
  departments?: Department[];
  direction?: UniversalObject;
  year: number;
  setYear: React.Dispatch<React.SetStateAction<number>>;
  quarterIndex: number;
  setQuarterIndex: React.Dispatch<React.SetStateAction<number>>;
  statusQuestionnaire?: StatusQuestionnaire;
  custom?: boolean;
  dataSummary?: DirectionsRequirement[];
  user?: unknown;
  currentDate: unknown[];
  isNotEditQuestionnaire?: boolean;
  onButtonComplete?: () => void;
  onButtonReturn?: () => void;
};

const quarters: Quarter[] = ['Q1', 'Q2', 'Q3', 'Q4'];

function ActionList(props: ActionListProps) {
  const { group, factory, gop, dataMain, departments, direction, year, setYear, quarterIndex, setQuarterIndex, statusQuestionnaire, custom, dataSummary, user, currentDate, isNotEditQuestionnaire, onButtonComplete, onButtonReturn } = props;

  const isShowButtonComplete = statusQuestionnaire !== 'Завершено' && !isNotEditQuestionnaire;

  const date = getCurrentQuarterAndYear(currentDate);

  const quarter =  quarters[quarterIndex];

  // Получаем актуальную дату завершения опросника
  const finishDate = currentDate.find((item) => item.quarter === quarter && item.year === year)?.finishDate;

  const isShowButtonReturn =
    statusQuestionnaire === 'Завершено' &&
    (
      (user.infoVPO.user && !user.infoVPO.adminRegion && !user.infoVPO.admin ? false :
        (user.infoVPO.admin && new Date() < new Date(finishDate)) ||
        user.infoVPO.adminRegion
      )
    );

  return (
    <div className="flex gap-3 bg-[#F3F4F6] pb-2 pt-1">
      <ChoosingMonth
        year={year}
        setYear={setYear}
        quarterIndex={quarterIndex}
        setQuarterIndex={setQuarterIndex}
        statusQuestionnaire={statusQuestionnaire}
        currentDate={date}
        custom={custom}
      />

      {custom
        ?
          <ExportExcelSummary data={dataSummary} params={{year, group, factory, gop}} />
        :
          <ExportExcelMain data={dataMain} departments={departments} params={{factory, gop, direction}} />
      }

      {custom
        ?
          null
        :
          isShowButtonComplete && user.displayName && (
            <button type="button"
              className="rounded-md px-6 py-4 shadow-md bg-[#012169] text-white"
              onClick={onButtonComplete}
            >
              Завершить оценку
            </button>
          )
      }

      {custom
        ?
          null
        :
          isShowButtonReturn && user.displayName && (
            <button type="button"
              className="rounded-md px-6 py-4 shadow-md bg-white text-[#012169]"
              onClick={onButtonReturn}
            >
              Вернуть в работу
            </button>
          )
      }
    </div>
  );
}

export default ActionList;
